import i18n from "@microdoing/shared/i18n";
import { cancelSelectedStepRequest } from "@microdoing/shared/services/userCampaign/actions";
import {
  Box,
  MainButton,
  MainText,
  MySafeAreaView,
  PressableOpacity,
} from "app/components/common";
import React, { useEffect } from "react";
import { useState } from "react";
import { ScrollView } from "react-native";
import CheckBox from "react-native-check-box";
import { useDispatch, useSelector } from "react-redux";
import { getCampaignRequesting } from "@microdoing/shared/services/userCampaign/selectors";
import theme from "app/Theme/Theme";
import WebDesktopView from "app/components/common/Web/WebDesktopView";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { breadCrumbsCancelActionScreen } from "app/navigation/breadcrumb/BreadcrumbPaths";
import HeaderScreen from "app/components/common/HeaderScreen";
import OptionBar from "./OptionBar";

const CancelActionScreen = () => {
  const [option, setOption] = useState("");
  const [comment, setComment] = useState("");
  const [isDoItLaterOptionChecked, setDoItLaterOption] = useState(false);

  const dispatch = useDispatch();
  const requesting = useSelector(getCampaignRequesting);

  useEffect(() => {
    if (option !== "other-reason") {
      setComment("");
    }
  }, [option]);

  const pressOption = optionSelected => () => {
    setOption(optionSelected);
  };

  const cancelActionSubmit = () => {
    dispatch(
      cancelSelectedStepRequest({
        hasRequestedForUnblock: true,
        comment,
        reason: option,
        isDoItLaterOptionChecked,
      }),
    );
  };

  const options = [
    { value: "too-hard", title: "cancel-action-too-hard" },
    { value: "too-long", title: "cancel-action-too-long" },
    { value: "other-people", title: "cancel-action-other-people" },
    { value: "other-reason", title: "cancel-action-other-reason" },
  ];

  const displayOption = () => {
    return options.map((el, i) => {
      return (
        <OptionBar
          key={i}
          opacity={option !== "" && option !== el.value ? 0.5 : 1}
          onPress={pressOption(el.value)}
          isSelected={option === el.value}
          text={i18n.t(el.title)}
          comment={comment}
          setComment={setComment}
        />
      );
    });
  };

  return (
    <WebDesktopView breadcrumbsPath={breadCrumbsCancelActionScreen}>
      <MySafeAreaView
        paddingVertical="xs"
        paddingHorizontal={{ phone: "xm", smallWeb: "null" }}
        backgroundColor="neutral.white"
        flex={1}
        flexDirection="column"
      >
        {!isWebDesktop && (
          <HeaderScreen leftIcon title={i18n.t("change-action")} />
        )}
        <MainText variant="l5-bold" marginBottom="xs">
          {i18n.t("what-happened")}
        </MainText>
        <MainText variant="l4-medium" color="neutral.600" marginBottom="xm">
          {i18n.t("change-action-explanation")}
        </MainText>
        <ScrollView>
          {displayOption()}
          <Box
            flex={1}
            width="100%"
            alignItems="center"
            justifyContent="flex-end"
            flexDirection="column"
            paddingBottom="sm"
          >
            <PressableOpacity onPress={() => setDoItLaterOption(prev => !prev)}>
              <Box
                alignSelf="flex-start"
                width="100%"
                flexDirection="row"
                justifyContent="flex-start"
                alignItems="center"
              >
                <CheckBox
                  checkBoxColor={theme.colors["brand.500"]}
                  onClick={() => setDoItLaterOption(!isDoItLaterOptionChecked)}
                  isChecked={isDoItLaterOptionChecked}
                />
                <MainText variant="l4-medium" marginLeft="s">
                  {i18n.t("do-this-challenge-later")}
                </MainText>
              </Box>
            </PressableOpacity>
          </Box>
        </ScrollView>
        <MainButton
          isDisabled={option === ""}
          isLoading={requesting}
          onPress={cancelActionSubmit}
          text={i18n.t("change-action")}
        />
      </MySafeAreaView>
    </WebDesktopView>
  );
};

export default CancelActionScreen;
